export function Section({ title, action, children }) {
  return (
    <div className="bg-white rounded-2xl shadow p-4">
      {(title || action) && (
        <div className="flex items-center justify-between mb-2">
          {title && (
            <h2 className="text-sm font-semibold text-stone-700">{title}</h2>
          )}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function Stat({ value, label }) {
  return (
    <div>
      <div className="text-2xl font-bold text-stone-800">{value}</div>
      <div className="text-xs text-stone-500">{label}</div>
    </div>
  );
}

export function ErrorBox({ message }) {
  if (!message) return null;
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700">
      {message}
    </div>
  );
}

export function EmptyState({ children }) {
  return <p className="text-sm text-stone-500">{children}</p>;
}

export function LoadingSpinner() {
  return <div className="text-sm text-stone-500">Loading…</div>;
}
